import { useTheme } from "aldoo-ra/SiteTheme/react-helpers"
import React from "react"
import HeaderSection from "./IndexPage/HeaderSection"
import StatisticsCards from "./StatisticsCards"
import CitationSection from "./IndexPage/CitationSection"
import AppDictionarySection from "./IndexPage/AppDictionarySection"
import HomeCardsSection from "./IndexPage/HomeCardsSection"
import PartnershipSection from "./IndexPage/PartnershipSection"
import PartnershipBubbleBanner from "./IndexPage/PartnershipBubbleBanner"
import TestimonialsSection from "./TestimonialsSection"
import StartJourneySection from "./StartJourneySection"

const IndexPage = () => {
  useTheme()

  return (
    <>
      <HeaderSection />
      <StatisticsCards />
      <CitationSection />
      <HomeCardsSection />
      <AppDictionarySection />
      <PartnershipSection />
      <PartnershipBubbleBanner />
      <TestimonialsSection 
        tid="mobilingo_app_ratings" 
        bgColor="bg-orange_lt" 
      />
      <StartJourneySection />
    </>
  )
}

export default IndexPage